import React, { useState } from 'react';
import {
  Box,
  Checkbox,
  ListItemText,
  Menu,
  MenuItem,
  IconButton,
  Badge
} from '@mui/material';
import { FilterList } from '@mui/icons-material';

const CheckboxIconMenu = ({ style, options = [], initialSelected = [], onChange, enableBadge = false }) => {
  const [selectedOptions, setSelectedOptions] = useState(initialSelected);
  const [anchorEl, setAnchorEl] = useState(null);

  const open = Boolean(anchorEl);

  const handleOpen = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const handleToggle = (option) => {
    const newSelected = selectedOptions.includes(option)
      ? selectedOptions.filter(item => item !== option)
      : [...selectedOptions, option];

    setSelectedOptions(newSelected);
    if (onChange) onChange(newSelected);
  };

  return (
    <Box style={style}>
      <Badge
        badgeContent={selectedOptions.length}
        color="secondary"
        variant='dot'
        overlap='circular'
        invisible={!enableBadge}
      >
        <IconButton color="primary" onClick={handleOpen}>
          <FilterList />
        </IconButton>
      </Badge>

      <Menu
        anchorEl={anchorEl}
        open={open}
        onClose={handleClose}
      >
        {options.map((option) => (
          <MenuItem
            key={option}
            onClick={() => handleToggle(option)}
          >
            <Checkbox
              size="small"
              checked={selectedOptions.includes(option)}
            />
            <ListItemText primary={option} />
          </MenuItem>
        ))}
      </Menu>
    </Box>
  );
};

export default CheckboxIconMenu;
